import { Fragment, FC, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { classes, style } from 'typestyle'

import useBoolean from '../../../hooks/use-boolean'

import { Box } from '../../../components/box/box.component'
import { Line } from '../../../components/line'
import { NavItem } from './nav-item'
import { Text } from '../../../components/text/text.component'

import { mb8 } from '../../../styles/styleset/margin/mb8'
import { mt4 } from '../../../styles/styleset/margin/mt4'
import { w100 } from '../../../styles/styleset/width/w100'
import { paddingLeftOuter, paddingRightOuter } from '../../../styles/default/padding'
import { mt8 } from '../../../styles/styleset/margin/mt8'

export const NavItemWrapper: FC<{ className?: string; children: any; onClick?: any }> = props => {
  const { className, children, onClick } = props
  const pads = classes(className)

  return (
    <Box baseline="none" className={pads} onClick={onClick} fullWidth row>
      {children}
    </Box>
  )
}

const cached: any = {}
const Hidable = (props: any) => {
  const [toggled, $toggled] = useBoolean(
    cached[props.identifier] !== undefined ? cached[props.identifier] : true,
  )

  useEffect(() => {
    cached[props.identifier] = toggled
  }, [toggled])

  return (
    <>
      {props.children({
        toggled,
        toggle: $toggled.toggle,
      })}
    </>
  )
}

const INDENT_SIZE = 8

export const renderItems = (props: {
  links: any
  history: any
  position?: string
  nested?: boolean
  disableHighlight?: boolean
  topLevel?: boolean
  padForLogo?: boolean
  breadcrumbs?: any
  isButton?: any
}) => {
  const { links, history, position, nested, disableHighlight, padForLogo, breadcrumbs } = props

  const items = links.filter((a: any) => a && a.position === position).filter((a: any) => !!a)

  if (items.length === 0) {
    return
  }

  return items.map((item: any, key: number) => {
    const highlight = !disableHighlight && history.location.pathname === item.to

    const semiHighlight =
      (!disableHighlight &&
        (breadcrumbs || []).some((b: any) => {
          if (b.to === item.to) {
            return true
          }
        })) ||
      item.semiHighlighted

    if (item) {
      switch (item.type) {
        case 'group':
          return (
            <Fragment key={key}>
              <Box baseline="none">
                {key !== 0 && (
                  <Box
                    baseline="none"
                    className={classes(mb8, mt8, paddingLeftOuter, paddingRightOuter)}
                    row
                  >
                    <Line />
                  </Box>
                )}
                <Box
                  baseline="none"
                  row
                  // style={{
                  //   paddingLeft: item.indent * 4,
                  // }}
                >
                  {item.children && item.children.length > 0 && (
                    <>
                      <Hidable identifier={`${item.label}-${key}`}>
                        {(params: any) => {
                          const { toggled, toggle } = params
                          return (
                            <>
                              {item.label && (
                                <NavItemWrapper>
                                  <Box
                                    minHeight={24}
                                    alignCenterY
                                    onClick={() => {
                                      toggle()
                                    }}
                                    className={style({
                                      transition: '.1s all ease',
                                      $nest: {
                                        '&:hover': {
                                          opacity: 0.8,
                                        },
                                      },
                                    })}
                                  >
                                    <Box
                                      baseline="none"
                                      className={classes(
                                        w100,
                                        paddingLeftOuter,
                                        paddingRightOuter,
                                        style({
                                          userSelect: 'none',
                                          color: '#515e6b',
                                          justifyContent: 'space-between',
                                          display: 'flex',
                                          cursor: 'pointer',
                                        }),
                                      )}
                                    >
                                      <Text size="xs" shrink uppercase semiBold disableMediaQuery>
                                        <span>{item.label}</span>
                                      </Text>
                                      <i
                                        className={classes(
                                          'material-icons',
                                          style({ fontSize: '14px !important' }),
                                        )}
                                      >
                                        {toggled ? 'arrow_drop_up' : 'arrow_drop_down'}
                                      </i>
                                    </Box>
                                  </Box>
                                </NavItemWrapper>
                              )}
                              {toggled && item.children && item.children.length && (
                                <Box baseline="none">
                                  {!disableHighlight &&
                                  !item.children.some((a: any) => a.type === 'group')
                                    ? renderItems({
                                        links: item.children,
                                        history,
                                        nested,
                                        padForLogo,
                                        breadcrumbs,
                                      })
                                    : renderItems({
                                        links: item.children,
                                        history,
                                        nested,
                                        padForLogo,
                                        disableHighlight,
                                        breadcrumbs,
                                      })}
                                </Box>
                              )}
                            </>
                          )
                        }}
                      </Hidable>
                    </>
                  )}
                </Box>
              </Box>
            </Fragment>
          )
        case 'sub-group':
          if (item.children.length === 0) return
          let color = '#515e6b'

          if (item.depth == 1) {
            color = '#543ecb'
          } else if (item.depth > 1) {
            color = '#8f27fa'
          }

          return (
            <Fragment key={key}>
              <Box baseline="none">
                <Box baseline="none" row>
                  {
                    <>
                      <Hidable identifier={`${item.label}-${key}`}>
                        {(params: any) => {
                          const { toggled, toggle } = params
                          return (
                            <>
                              {item.label && (
                                <NavItemWrapper>
                                  <Box
                                    minHeight={24}
                                    alignCenterY
                                    onClick={() => {
                                      toggle()
                                    }}
                                    className={classes(
                                      paddingLeftOuter,
                                      style({
                                        transition: '.1s all ease',
                                        $nest: {
                                          '&:hover': {
                                            opacity: 0.8,
                                          },
                                        },
                                      }),
                                    )}
                                  >
                                    <Box
                                      baseline="none"
                                      className={classes(
                                        w100,
                                        paddingRightOuter,
                                        style({
                                          userSelect: 'none',
                                          color,
                                          paddingLeft:
                                            (item.indent || 0) * INDENT_SIZE -
                                            (item.indent ? INDENT_SIZE : 0),
                                          // minWidth: '246px',
                                          justifyContent: 'space-between',
                                          display: 'flex',
                                          cursor: 'pointer',
                                        }),
                                      )}
                                    >
                                      <Text size="xs" shrink uppercase semiBold disableMediaQuery>
                                        <span>{item.label}</span>
                                      </Text>
                                      <i
                                        className={classes(
                                          'material-icons',
                                          style({ fontSize: '14px !important' }),
                                        )}
                                      >
                                        {toggled ? 'arrow_drop_up' : 'arrow_drop_down'}
                                      </i>
                                    </Box>
                                  </Box>
                                </NavItemWrapper>
                              )}
                              {toggled && (
                                <Box baseline="none">
                                  {!disableHighlight &&
                                  !item.children.some((a: any) => a.type === 'group')
                                    ? renderItems({
                                        links: item.children,
                                        history,
                                        nested,
                                        padForLogo,
                                        breadcrumbs,
                                      })
                                    : renderItems({
                                        links: item.children,
                                        history,
                                        nested,
                                        padForLogo,
                                        disableHighlight,
                                        breadcrumbs,
                                      })}
                                </Box>
                              )}
                            </>
                          )
                        }}
                      </Hidable>
                    </>
                  }
                </Box>
              </Box>
            </Fragment>
          )
        case 'subtitle':
          return (
            <Box
              baseline="none"
              className={classes(w100, paddingLeftOuter, paddingRightOuter)}
              key={key}
            >
              <Text size="xs" shrink uppercase semiBold disableMediaQuery>
                {item.label}
              </Text>
            </Box>
          )
        case 'break':
          return (
            <NavItemWrapper className={classes(mb8, mt4)} key={key}>
              <Line />
            </NavItemWrapper>
          )

        default:
          if (!item.to) {
            return (
              <NavItemWrapper onClick={item.onClick} key={key}>
                <NavItem
                  parentLabel={item.parentLabel}
                  label={item.label}
                  icon={item.icon}
                  help={item.help}
                  padForParent={key !== 0 && nested}
                  padForLogo={padForLogo}
                  disableHighlight={props.disableHighlight}
                  indent={item.indent}
                />
              </NavItemWrapper>
            )
          }

          return (
            <div key={item.to} data-highlight={highlight}>
              {(() => {
                if (highlight) {
                  return (
                    <NavItemWrapper>
                      <NavItem
                        parentLabel={item.parentLabel}
                        label={item.label}
                        icon={item.icon}
                        highlight={highlight}
                        padForParent={key !== 0 && nested}
                        padForLogo={padForLogo}
                        disableHighlight={props.disableHighlight}
                        indent={item.indent}
                      />
                      {/* {key == 0 && nested && <Line />} */}
                    </NavItemWrapper>
                  )
                } else if (semiHighlight) {
                  return (
                    <NavItemWrapper>
                      <Link to={item.to}>
                        <NavItem
                          position={position}
                          parentLabel={item.parentLabel}
                          label={item.label}
                          icon={item.icon}
                          semiHighlight={highlight || semiHighlight}
                          padForParent={key !== 0 && nested}
                          padForLogo={padForLogo}
                          disableHighlight={props.disableHighlight}
                          indent={item.indent}
                        />
                      </Link>
                      {/* {key == 0 && nested && <Line />} */}
                    </NavItemWrapper>
                  )
                } else {
                  return (
                    <NavItemWrapper>
                      <Link to={item.to}>
                        <NavItem
                          position={position}
                          parentLabel={item.parentLabel}
                          label={item.label}
                          icon={item.icon}
                          padForParent={key != 0 && nested}
                          padForLogo={padForLogo}
                          disableHighlight={props.disableHighlight}
                          isButton={props.isButton}
                          indent={item.indent}
                        />
                      </Link>
                      {/* {key == 0 && nested && <Line />} */}
                    </NavItemWrapper>
                  )
                }
              })()}
            </div>
          )
      }
    }
  })
}
